export enum AvailabilityLabels {
    FOR_COURSES = 'forCourses',
    FOR_HANDOUT_EVENTS = 'forHandoutEvents',
    FOR_ONLINE_COURSES = 'forOnlineCourses',
    EXCEPTIONAL = 'exceptional',
    /** Window reserved for make-up lessons (Nachholtermine); only for Standorte and Lehrkräfte (mirror of shrd) */
    FOR_MAKEUP = 'forMakeup',
}

/** True if the window carries only FOR_MAKEUP: it is no regular course availability (mirror of shrd) */
export function isMakeupOnlyAvailability(availability: { labels?: string[] } | null | undefined): boolean {
    const labels = availability?.labels || [];
    return labels.length > 0 && labels.every((label) => label === AvailabilityLabels.FOR_MAKEUP);
}

export const AvailabilityLabelsVue = [{
    value: AvailabilityLabels.FOR_COURSES,
    color: 'info',
    text: 'Für Kurse',
}, {
    value: AvailabilityLabels.FOR_HANDOUT_EVENTS,
    color: 'success',
    text: 'Für Austeilaktionen',
}, {
    value: AvailabilityLabels.FOR_ONLINE_COURSES,
    color: 'green lighten-3',
    text: 'Für Online-Kurse',
}, {
    value: AvailabilityLabels.EXCEPTIONAL,
    color: 'warning',
    text: 'In Ausnahmefällen',
}, {
    value: AvailabilityLabels.FOR_MAKEUP,
    color: 'purple',
    text: 'Für Nachholtermine',
}];
